module.exports = __webpack_public_path__ + "static/img/公众号.c72f659.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/公众号.png
// module id = yVrx
// module chunks = 11